<h1 mat-dialog-title class="text-center">{{data.title}}<br><br></h1>
<div mat-dialog-content [ngClass]="{'text-danger fs-4': data.needsCloseButton}" class="analysis-dialog fs-6">
    {{data.message}}
</div>
<div class="flex-grow-1 d-flex justify-content-center">
    <button *ngIf="data.needsCloseButton" class="m-3 fs-5 px-4 py-1" color="primary" mat-raised-button type='submit'
            (click)="onClose()">Close
    </button>
</div>
